import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";

import { App } from "./App";

import "./index.css";

ReactDOM.render(<App />, document.getElementById("root"));

reportWebVitals();
